import React from 'react';
import PropTypes from 'prop-types';

import { toGenericInputCreateRequest } from './formDataAdapter';
import GenericS3 from './GenericS3';
import INITIAL_FORMDATA from './_initialFormData';

import { AdvancedOptionsProvider } from '../common/context/AdvancedOptions';
import { SidebarProvider } from '../common/context/Sidebar';
import { StepsProvider } from '../common/context/Steps';
import { FormDataProvider } from '../common/context/FormData';

type Props = {
  onSubmit: (InputCreateRequest) => void,
};

const EmbeddedGenericS3App = ({ onSubmit }: Props) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }

    onSubmit(toGenericInputCreateRequest(formData));
  };

  return (
    <StepsProvider>
      <FormDataProvider initialFormData={INITIAL_FORMDATA}>
        <SidebarProvider>
          <AdvancedOptionsProvider>
            <GenericS3 onSubmit={handleSubmit} externalInputSubmit={typeof onSubmit === 'function'} />
          </AdvancedOptionsProvider>
        </SidebarProvider>
      </FormDataProvider>
    </StepsProvider>
  );
};

EmbeddedGenericS3App.propTypes = {
  onSubmit: PropTypes.func,
};

EmbeddedGenericS3App.defaultProps = {
  onSubmit: undefined,
};

export default EmbeddedGenericS3App;
